import type {PS} from '@wix/document-services-types'
const refresh = (ps: PS) => ps.siteAPI.refreshCustomStyles()
export default {
    refresh
}
